import { render, staticRenderFns } from "./QueueDetailInfo.vue?vue&type=template&id=42f23157&scoped=true&"
import script from "./QueueDetailInfo.vue?vue&type=script&lang=js&"
export * from "./QueueDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./QueueDetailInfo.vue?vue&type=style&index=0&id=42f23157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f23157",
  null
  
)

export default component.exports